// extracted by mini-css-extract-plugin
export default {"reveal":"Reveal_reveal__67Wkx","visible":"Reveal_visible__9Qom4"};